const messages = {
    availPoints: "Razpoložljive točke",
    awaitingPoints: "Točke v čakanju",
  board: {
    title: "Nadzorna plošča",
    title2: "Animacija učinkovitosti {year}",
    headline1: "Vaše promocije in točke na prvi pogled",
    headline2: "Zaslužite točke za nakupe pnevmatik.",
    pointsBalanceToDate: "STANJE TOČK NA DATUM",
    availPoints: "Razpoložljive točke",
    awaitingPoints: "Točke v čakanju",
    yourRealisation: "VAŠI DOSEŽKI",
    yourEngagement: "Vaša letna obveznost: <b>pnevmatike {tyres}</b>",
    yourPoints: "VAŠE TOČKE",
    yourRetailPurchase: "VAŠI MALOPRODAJNI NAKUPI",
    yourRetailPurchaseCCS: "VAŠA MALOPRODAJA",
    pointsByPurchase: "točk, ustvarjenih z vašimi nakupi",
    pointsByBoosters: "točk, ki jih ustvarijo pospeševalci",
    pointsByBSPurchase: "Točke, ustvarjene z vašimi nakupi Bridgestone",
    pointsByBSPurchaseCCS:
      "Točke, ustvarjene z vašo prodajo pnevmatik Bridgestone",
    remaining: "Preostale gume",
    yourGoal: "Ciljni napredek",
    unit: "pnevmatike",
    buttons: {
      learnMore: "Več o vaših točkah",
      learnMoreAboutMechanism: "Izvedite več o mehaniki",
    },
    charts: {
      byBrand: "Po znamki",
      bySize: "Po velikosti<br/>platišča",
    },
    exploreResults: "Odkrijte svoje rezultate",
    tyreLimitInfo:
      "Za vsako obdobje kampanje Booster je zahtevan najmanjši obseg razprodaje 50 pnevmatik Bridgestone in/ali Firestone.",
  },
  charts: {
    byBrand: "Po znamki",
    bySize: "po velikosti platišča",
  },

  dashboard: {
    dashboardTitle: "Vaše ugodnosti",
    dashboardBox: {
      title: "Stanje točk",
      description: "Vaše trenutne skupne tržne točke",
      availPoints: "Razpoložljive točke",
      awaitingPoints: "Točke v čakanju",
      lastUpdate: "Zadnja posodobitev",
      button: "Več o tem",
      points: "points",
    },
  },
  soldTyres: "PNEVMATIKE PRODANE",
  receivedPoints: "PRIDOBLJENE TOČKE",
  boosterCCS: {
    personalInfo: "Osebni podatki",
    csNumberTitle: "Navedite številko(-e) sodelujočega računa",
    tyresTitle: "Prosimo navedite število prodanih pnevmatik",
    minTyresInfo:
      "Zahtevane so najmanj {tyres} pnevmatike Bridgestone/Firestone. Odškodnina velja samo za pnevmatike Bridgestone.",
    tyresAmount: "Št. pnevmatik",
    filesTitle: "Naložite svoje dokazilo o prodaji",
    filesDescription:
      "Prosimo, upoštevajte: upoštevane bodo samo prodaje, ki določajo velikost platišč pnevmatik.",
    addAnotherFile: "Dodajte še en dokument",
    file: "Naloži dokument",
    formatInfo:
      "Podprti formati datotek: xlsx, jpeg in pdf. Največja velikost datoteke: 8 MB",
    confrimationMessage:
      "<b>Zahvaljujemo se vam za sodelovanje!</b> <br/>Vašo zahtevo smo prejeli in posredovali ekipam Bridgestone v potrditev.<br/>Prejeli boste e-poštno obvestilo z rezultati vašega sodelovanja v Booster CCS.<br/>Se vidimo kmalu na Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Delite točke",
    forShare: "Točke, ki jih boste delili",
    title: "Naslov",
  },
  notFoundFile: "Noben izbran",
  chooseFile: "Izberite datoteko",
};
export default {
  messages,
};
